<template>
<div class="chapter">
<div class="inner_page">
<div class="C180">
<p class="C275">. . . . . <a id="page_xxvi"></a>a faith sincere</p>
<p class="C276">Drawn from the wisdom that begins with fear</p>
<p class="C276">WORDSWORTH.—<em>Second Evening Voluntary</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0009.vue?221fb0df